/**
 * Formats a YYYY/MM/DD (or YYYY-MM-DD) delivery date for matrix headers and date chips.
 * Uses Canadian locales so French UI shows French weekday/month names.
 *
 * @param deliveryDate Arrival date as YYYY/MM/DD or YYYY-MM-DD
 * @param locale Active UI locale (`en` | `fr`)
 * @returns Localized short date label (e.g. `Mon, Apr 13` / `lun. 13 avr.`)
 */
export function formatDeliveryDateLabel(deliveryDate: string, locale: 'en' | 'fr'): string {
  const normalized = deliveryDate.replaceAll('-', '/');
  const [year, month, day] = normalized.split('/').map((part) => Number.parseInt(part, 10));
  if (!year || !month || !day) {
    return deliveryDate;
  }

  const date = new Date(Date.UTC(year, month - 1, day));
  return new Intl.DateTimeFormat(locale === 'fr' ? 'fr-CA' : 'en-CA', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  }).format(date);
}
